import TagsList from "components/TagsList";
import FormField from "ds/components/Form/Field";
import Typography from "ds/components/Typography";

import FieldsGroup from "../FieldsGroup";
import { ScanDetailsDrawerItem } from "../types";

type ScopeTabProps = {
  scope: ScanDetailsDrawerItem["scope"];
};

const ScopeTab = ({ scope }: ScopeTabProps) => {
  const resourceTypes = scope.map(({ type }) => type);

  return (
    <FieldsGroup>
      <FormField label="Resource types" noMargin>
        {resourceTypes.length > 0 ? (
          <TagsList tags={resourceTypes} alwaysExpanded />
        ) : (
          <Typography tag="span" variant="p-body3" color="disabled">
            None
          </Typography>
        )}
      </FormField>
    </FieldsGroup>
  );
};

export default ScopeTab;
